"use client";
import { ICartItemType } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { getCartItemFromProductToEvent } from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/helpers/functions";
import { EventType } from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/helpers/interfaces";
import useEventTrackers from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/useEventTrackers";
import { useEffect } from "react";

const ViewCategoryPixel = ({
  products,
  item_list_id,
  item_list_name,
}: {
  products: IProduct[];
  item_list_name: string;
  item_list_id: string;
}) => {
  const { eventTrackers } = useEventTrackers();
  const handleTimerEnd = () => {
    console.log("gg")
    eventTrackers(
      EventType.view_item_list,
      [
        ...(products.map((product) => ({
          ...getCartItemFromProductToEvent({
            parent: { name: product.name, sku: product.sku },
            inner_id: product.id,
            discount: product.discount!,
            name: product.name,
            type: product.preview_type as ProductPreviewTypes,
            quantity: 1,
            price: product.price,
            categories_names: product?.categories_names ?? [],
          }),
        })) as unknown as ICartItemType[]),
      ],
      {
        item_list_id: item_list_id,
        item_list_name: item_list_name,
      },
    );
  };
  useEffect(() => {
    if (products.length < 1) return;
    let time = 1;

    const timerId = setInterval(() => {
      if (time === 0) {
        clearInterval(timerId);
        handleTimerEnd();
      } else {
        time -= 1;
      }
    }, 1000);

    return () => clearInterval(timerId);
  }, [products]);

  return <></>;
};

export default ViewCategoryPixel;
